import React, { useEffect, useRef, useState } from "react";
import "./Search.scss";
import { ProductApi } from "services/ProductApi";
import Helpers from "@utils/Helpers";
import { errorLog } from "logging";
import ProductFilter from "@containers/ProductFilter/ProductFilter";
import ProductList from "@containers/ProductList/ProductList";
import { Col, Empty, Row, Select } from "antd";
import ProductMap from "@components/ProductMap/ProductMap";

const { Option } = Select;
let debounceTimer: any;

const Search: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const encodedData = urlParams.get("params");
  const params = JSON.parse(decodeURIComponent(encodedData!));
  const [isLargeMode, setIsLargeMode] = useState(false);
  const [searchData, setSearchData] = useState<any>(null);
  const [isOpenMap, setIsOpenMap] = useState(false);
  const [sortBy, setSortBy] = useState<any>(null);
  const [searchParam, setSearchParam] = useState<any>(params);

  useEffect(() => {
    handleSearch();
  }, []);

  const prevSearchParamRef: any = useRef();

  useEffect(() => {
    const prevSearchParam: any = prevSearchParamRef.current;
    const shouldFetchData = Object.keys(searchParam).some((key) => {
      if (key === "address" || key === "filters") return false;
      return searchParam[key] !== prevSearchParam?.[key];
    });

    if (shouldFetchData) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => {
        handleSearch();
      }, 300);
    }

    prevSearchParamRef.current = searchParam;
  }, [searchParam]);

  const handleSearch = async () => {
    const payload = structuredClone(searchParam);
    const baleWeightMin = Number(searchParam.filters?.bale_weight_min) || 0;
    const baleWeightMax = Number(searchParam.filters?.bale_weight_max) || 0;
    payload.filters.bale_weight_min = baleWeightMin * 1000;
    payload.filters.bale_weight_max = baleWeightMax * 1000;

    setSearchData(null);
    try {
      const response = await ProductApi.Search(payload);
      if (response.status === 200) {
        setSearchData(response.data);
      }
    } catch (error) {
      Helpers.notification.error("Can not search product. Please try again");
      errorLog("ProductCatalog.tsx - handleSearch", error);
    }
  };
  const handleChangeSortBy = (value: string) => {
    setSortBy(value);
    let sortedProduct;
    switch (value) {
      case "1":
        sortedProduct = searchData.sort(
          (item1: any, item2: any) =>
            item1.price_per_tons - item2.price_per_tons
        );
        setSearchData(sortedProduct);
        break;
      case "2":
        sortedProduct = searchData.sort(
          (item1: any, item2: any) =>
            item2.price_per_tons - item1.price_per_tons
        );
        setSearchData(sortedProduct);
        break;
      case "3":
        sortedProduct = searchData.sort(
          (item1: any, item2: any) =>
            item2.price_per_tons - item1.price_per_tons
        );
        setSearchData(sortedProduct);
        break;
      case "4":
        sortedProduct = searchData.sort(
          (item1: any, item2: any) =>
            item2.price_per_tons - item1.price_per_tons
        );
        setSearchData(sortedProduct);
        break;
      default:
        break;
    }
  };

  return (
    <div className="Search">
      <div className="container">
        <ProductFilter
          searchParam={searchParam}
          setSearchParam={setSearchParam}
          setIsOpenMap={setIsOpenMap}
          isOpenMap={isOpenMap}
          componentIn={"search"}
          submit={handleSearch}
          isLargeMode={isLargeMode}
          setIsLargeMode={setIsLargeMode}
        />
        <div className="result-wrap">
          <Row gutter={16}>
            <Col span={isOpenMap ? 12 : 24}>
              <div className={`result-group ${isOpenMap ? "map" : ""}`}>
                {searchData && searchData.length === 0 ? (
                  <Empty
                    className="empty-section"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ) : (
                  <ProductList
                    type="Results"
                    isOpenMap={isOpenMap}
                    products={searchData}
                    isLargeMode={isLargeMode}
                    setIsLargeMode={setIsLargeMode}
                    additional={
                      <Select
                        size="large"
                        className="sort-by-select"
                        variant="filled"
                        value={sortBy}
                        placeholder="Sort by"
                        onChange={handleChangeSortBy}
                      >
                        <Option value="1">Lowest Price</Option>
                        <Option value="2">Highest Price</Option>
                      </Select>
                    }
                  />
                )}
              </div>
            </Col>
            {isOpenMap && (
              <Col span={12}>
                <div className="product-map-wrap">
                  <ProductMap
                    productNearBy={searchData}
                    searchParam={searchParam}
                    isProductDetail={false}
                  />
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Search;
